import classNames from 'classnames';
import { useState } from 'react';
import ArrowSelect from '@/svg/arrow-select.svg?url';

type Props = {
    prices: string[];
    classname?: string;
};

export const CurrencyDropdown = ({ prices, classname }: Props) => {
    const [open, setOpen] = useState(false);

    return (
        <div
            className={classNames(`currency-dropdown ${classname}`, {
                'currency-dropdown--open': open,
            })}
        >
            <button className="currency-dropdown__btn" onClick={() => setOpen((prev) => !prev)}>
                <span className="currency-dropdown__btn-text">{prices[0]}</span>
                <span className="currency-dropdown__btn-svg">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={ArrowSelect} alt="" width={7} height={8} className="img-fluid" decoding="async" />
                </span>
            </button>
            <ul
                className={classNames('currency-dropdown__list list-unstyled', {
                    'currency-dropdown__list--open': open,
                })}
            >
                {prices.slice(1).map((item) => (
                    <li key={item} className="currency-dropdown__list-item text-l">
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CurrencyDropdown;
